<template lang="html">
  <div class="comments-block" v-observe-visibility="loadFirstPage">

    <comment-form :target-type="targetType" :target-id="targetId" :language="language" @created="append"/>

    <div class="comment-list">
      <comment-item class="comment" v-for="comment in comments" :key="comment.id">
        <div class="content">
          <p>
            <strong :class="comment.user_id === $user.id ? 'me' : null">{{ comment.author }}</strong> <small><timeago :since="comment.created_at" :auto-update="60" :locale="language"/></small>
            <br>
            <nl2br tag="span" :text="comment.comment" />
          </p>
        </div>
      </comment-item>
    </div>

    <div class="comment-button" v-if="!lastPage">
      <div class="comment-button-area">
        <button class="button is-black is-outlined" @click="loadNextPage">
          Weitere Laden
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingIndicator from 'shared/components/LoadingIndicator.vue'
import Nl2br from 'vue-nl2br'
import CommentForm from './Form.vue'
import CommentItem from './Comment.vue'

export default {
  props: {
    targetType: {type: String, required: true},
    targetId: {type: [Number, String], required: true},
    language: {type: String, default: window.__INIT_DATA.lang}
  },

  components: {
    LoadingIndicator,
    Nl2br,
    CommentForm,
    CommentItem
  },

  data(){
    return {
      comments: [],
      pagination: {count: 0, page: 0, limit: 20},
      loading: false,
      loaded: false,
      retries: 0
    }
  },

  computed: {
    lastPage(){
      if(this.pagination.count === 0) return this.loaded
      return this.comments.length >= this.pagination.count
    }
  },

  methods: {
    loadFirstPage(isVisible){
      if(!this.loaded) this.load(1)
    },

    loadNextPage(){
      if(!this.loading) this.load(this.pagination.page + 1)
    },

    load(page){
      if(!this.targetId || !this.targetType) return

      this.loading = true

      return this.$api.getComments({page, limit: 5, target_id: this.targetId, target_type: this.targetType, language: this.language})
      .then(({comments, page, count, limit}) => {
        this.comments = this.comments
        .concat(comments)
        .filter((c, i, s) => s.findIndex(t => t.id === c.id) === i)
        .sort((a, b) => {
          if(a.created_at < b.created_at) return 1
          if(a.created_at > b.created_at) return -1
          return 0
        })
        this.pagination = {page, count, limit}
        this.loading = false
        this.loaded = true
        this.retries = 0
        this.$emit('count', count)
      })
      .catch(error => {
        console.error(error)
        this.loading = false
        this.retries++
      })
    },


    append(comment){
      this.comments.unshift(comment)
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/comment/List.vue